export default __webpack_public_path__ + "static/abstractbackground-a481682cb1a11fffd62809d2a2a3facc.jpg";